module.exports = __webpack_public_path__ + "static/media/gameStarball.07873076.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameStarball.png
// module id = 2644
// module chunks = 0